import { render, staticRenderFns } from "./ModalUpdateCategorie.vue?vue&type=template&id=6d261785"
import script from "./ModalUpdateCategorie.vue?vue&type=script&lang=js"
export * from "./ModalUpdateCategorie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports